import React from 'react';
import { PageWrapper } from '../../components/common';
import AltaAplicacion from '../../components/ordenes/altaaplicacion';

const AltaAplicacionPage: React.FC = () => {
  return (
    <PageWrapper>
      <AltaAplicacion />
    </PageWrapper>
  );
};

export default AltaAplicacionPage;

